/* Copyright (c) 2024 Xperi. All Rights Reserved. */

// eslint-disable-next-line no-shadow
export enum PCState {
    Locked,
    Unlocked,
    Off,
}
